const PLACEHOLDERS = [
  '#', 'http://', 'https://',
  't.me', 't.me/', 'https://t.me', 'https://t.me/', 'http://t.me/',
  'telegram.me', 'telegram.me/', 'https://telegram.me', 'https://telegram.me/', 'http://telegram.me/',
  'wa.me', 'wa.me/', 'https://wa.me', 'https://wa.me/', 'http://wa.me/',
  'https://api.whatsapp.com/send', 'https://api.whatsapp.com/send?phone=',
];

export function isValidLink(url) {
  if (typeof url !== 'string') return false;
  const v = url.trim();
  if (!v) return false;
  return !PLACEHOLDERS.includes(v.toLowerCase().replace(/\/+$/, '/'));
}
